import React, { createContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const PatrolReportListContext = createContext();

const PatrolReportListProvider = ({ children }) => {
  const [prlQuery, setPrlQuery] = useState('');
  const [prlPageValue, setPrlPageValue] = useState(1);
  const [prlPageSizeValue, setPrlPageSizeValue] = useState(10);
  const [prlValuesPresent, setPrlValuesPresent] = useState(false);
  const [prlSortField, setPrlSortField] = useState('');
  const [prlSortOrder, setPrlSortOrder] = useState('');

  const contextValue = useMemo(
    () => ({
      prlQuery,
      setPrlQuery,
      prlPageValue,
      setPrlPageValue,
      prlPageSizeValue,
      setPrlPageSizeValue,
      prlValuesPresent,
      setPrlValuesPresent,
      prlSortField,
      setPrlSortField,
      prlSortOrder,
      setPrlSortOrder,
    }),
    [prlQuery, prlPageValue, prlPageSizeValue, prlValuesPresent, prlSortOrder, prlSortField],
  );

  return (
    <PatrolReportListContext.Provider value={contextValue}>
      {children}
    </PatrolReportListContext.Provider>
  );
};

PatrolReportListProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { PatrolReportListContext, PatrolReportListProvider };
